import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const payoffQuoteIcon = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="4" y="2" width="16" height="20" rx="2" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 7V17M12 7C10.8954 7 10 7.67157 10 8.5C10 9.32843 10.8954 10 12 10C13.1046 10 14 10.6716 14 11.5C14 12.3284 13.1046 13 12 13C10.8954 13 10 13.6716 10 14.5C10 15.3284 10.8954 16 12 16" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <circle cx="12" cy="17" r="0.5" fill="#222222"/>
</svg>`
);
